// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CaseFollowUpScenario } from './caseFollowUpScenario.js';
import type { CaseFollowUpSyncAction } from './caseFollowUpSyncAction.js';
import type { ICaseRelationships } from './iCaseRelationships.js';
import type { ProgramCaseTypeModel } from './programCaseTypeModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Case Follow-Up Result Model
*/
export class CaseFollowUpResultModel {
    'caseSourceCode'?: string | null;
    'caseTypeToCreate'?: ProgramCaseTypeModel | null;
    'caseFollowUpSyncAction'?: CaseFollowUpSyncAction;
    'manualSyncCaseRelationships'?: ICaseRelationships | null;
    'scenario'?: CaseFollowUpScenario;
    'taskTypeCode'?: string | null;
    'taskBody'?: string | null;
    'taskDueDate'?: Moment;
    'taskDueTime'?: string | null;
    'syncableEntities': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CaseFollowUpResultModel>> = [
        {
            "name":     "caseSourceCode",
            "baseName": "caseSourceCode",
            "type":     "string"
        },
        {
            "name":     "caseTypeToCreate",
            "baseName": "caseTypeToCreate",
            "type":     "ProgramCaseTypeModel"
        },
        {
            "name":     "caseFollowUpSyncAction",
            "baseName": "caseFollowUpSyncAction",
            "type":     "CaseFollowUpSyncAction"
        },
        {
            "name":     "manualSyncCaseRelationships",
            "baseName": "manualSyncCaseRelationships",
            "type":     "ICaseRelationships"
        },
        {
            "name":     "scenario",
            "baseName": "scenario",
            "type":     "CaseFollowUpScenario"
        },
        {
            "name":     "taskTypeCode",
            "baseName": "taskTypeCode",
            "type":     "string"
        },
        {
            "name":     "taskBody",
            "baseName": "taskBody",
            "type":     "string"
        },
        {
            "name":     "taskDueDate",
            "baseName": "taskDueDate",
            "type":     "Date"
        },
        {
            "name":     "taskDueTime",
            "baseName": "taskDueTime",
            "type":     "string"
        },
        {
            "name":     "syncableEntities",
            "baseName": "syncableEntities",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return CaseFollowUpResultModel.attributeTypeMap;
    }
}
